export const colors = ["#D4220A", "#FF8A00", "#F3E734", "#AAE8A6", "#14C4A2", "#19DFE5", "#15A3F7", "#0819A0", "#422CCC", "#8B4BF9"];
export const randomColor = () => colors[Math.floor(Math.random() * colors.length)]!;
